var marketSelector = {
	selectionLabel: "Sélectionner un Marché"
};
var fr = {
	marketSelector: marketSelector
};

export { fr as default, marketSelector };
